import { render } from "./01-Auth.vue?vue&type=template&id=7ffe21cc"
import script from "./01-Auth.vue?vue&type=script&lang=js"
export * from "./01-Auth.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__